import { useSelector } from "../../../../hooks";
import { TaskContext } from "../../TasksTypes";
import { TaskTypeBlock } from "../../TaskTypeBlock";
import telegramIcon from "./icons/telegram.png";
import maxIcon from "./icons/max.svg";
import styles from "../../Block.module.scss";
import { useContextNavigate } from "../../../../hooks/navigate";
import { ActionPromptType } from "../../../../hooks/prompts";
import { isMaxPlatform } from "../../../../platform/platform";

export const JoinChannelBlock = () => {
    const joinChannelTasks = useSelector(store => store.tasks.joinChannelTasks);
    const navigate = useContextNavigate<TaskContext>();

    const getTelegramUnsubscribedChannelsCount = () => {
        const count = (joinChannelTasks?.activeTasks ?? []).reduce((acc, item) => {
            if (!item.subscribed)
                ++acc;
            return acc;
        }, 0);

        return count;
    }

    const isAllow = () => (joinChannelTasks?.activeTasks ?? []).length && getTelegramUnsubscribedChannelsCount() > 0
    
    const getJoinChannelDescription = () => {        
        if (!isAllow())
            return 'Нет доступных';

        const unsubscribed = getTelegramUnsubscribedChannelsCount();
        if (unsubscribed === (joinChannelTasks?.activeTasks ?? []).length)
            return <>Доступно <span className={styles.availableCount}>{unsubscribed}</span></>;

        return <>Доступно <span className={styles.availableCount}>{unsubscribed}</span> из {(joinChannelTasks?.activeTasks ?? []).length}</>;
    }

    const clickHandler = () => {
        navigate(TaskContext.JoinChannel)
    }

    return (        
        <TaskTypeBlock
            handler={ clickHandler }
            name='Подписаться на канал'
            icon={isMaxPlatform() ? maxIcon : telegramIcon}
            description={ getJoinChannelDescription() }
            iconTypeStyle={isMaxPlatform() ? 'iconTypeMax' : 'iconTypeTelegram'}
            promptType={ ActionPromptType.SUBSCRIPTION_ADD }
        />
    );
}